<script setup>
import { useLoadingBar } from '@/composables/loadingBar'

const { loadingBar } = useLoadingBar()
</script>

<template>
  <Transition name="fade">
    <div
      v-if="loadingBar"
      class="fixed top-0 left-0 h-1 w-full overflow-hidden bg-microsoft-blue-default/20 z-[1000]"
    >
      <div class="progress-bar-value w-full h-full bg-microsoft-blue-default" />
    </div>
  </Transition>
</template>

<style>

.progress-bar-value {
  animation: indeterminateAnimation 1s infinite linear;
  transform-origin: 0% 50%;
}

@keyframes indeterminateAnimation {
  0% {
    transform:  translateX(0) scaleX(0);
  }
  40% {
    transform:  translateX(0) scaleX(0.4);
  }
  100% {
    transform:  translateX(100%) scaleX(0.5);
  }
}
</style>
